import { render, staticRenderFns } from "./DashboardQuotationListing.vue?vue&type=template&id=b31b3916"
import script from "./DashboardQuotationListing.vue?vue&type=script&lang=js"
export * from "./DashboardQuotationListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports